module.exports = __webpack_public_path__ + "static/img/5areaA_4.76bb55a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/5areaA_4.png
// module id = 856
// module chunks = 1